<template>
  <div v-if="product.variationData" class="mt-2">
    <div v-for="attribute in attributes" :key="attribute.attribute_id">
      <div class="form-group">
        <label :for="`selected_value_${attribute.name}`" class="mb-1">{{ attribute.name }}</label>
        <select class="form-control" :id="`selected_value_${attribute.name}`" v-model="attribute.selected_value_id" @change="(e) => setAttributeValue(attribute, e)">
          <option :value="-1" selected disabled>Select {{ attribute.name }}</option>
          <option v-for="value in attribute.values" :value="value.value_id" :key="value.value_id">{{ value.value }}</option>
        </select>
        <p v-if="attribute.not_available" class="text-danger mt-1 mb-0">Not Available</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      product: Object,
      attributes: Object
    },
    mounted() {
      if (this.attributes) {
        this.attributes.forEach(attribute => {
          if (!attribute.selected_value_id) attribute.selected_value_id = -1
        })
      }

      if (this.product.variationData) {
        this.preloadVariationImages()
        this.loadIncluded()
      }
    },
    methods: {
      preloadVariationImages() {
        this.product.variationData.products.forEach(product => {
          if (product.images) {
            product.images.forEach(img => {
              new Image().src = img.url
              new Image().src = img.thumb_url
            })
          }
        })
      },
      loadIncluded() {
        this.product.variationData.products.forEach( included => {
          if (included.is_default) {
            this.$emit('setCartProduct', null)
            this.$emit('setCurrentProduct', included)
            this.$emit('setCartProduct', included)
            this.$emit('setDefaultProduct', included)
            this.$emit('setCurrentImage', included.image_url)
            this.$nextTick(() => {
              this.$emit('refresh')
            })
          }
        });
      },
      setAttributeValue(selectedAttribute, e) {
        let selected = false;
        
        this.attributes.forEach((attribute) => {
          attribute.not_available = false;
        });
        this.product.variationData.products.some((included) => {
          let values = included.values;
          selected = included;
          values.some((value) => {
            this.attributes.some((attribute) => {
              if (value.attribute_id == attribute.attribute_id) {
                if (value.value_id != attribute.selected_value_id) {
                  selected = false;
                  return true;
                }
              }
            });
          });

          return selected;
        });

        this.$emit('setCartProduct', selected)
        if (!selected) {
          if (selectedAttribute) selectedAttribute.not_available = true;
          this.$emit('setCurrentProduct', this.product)
          if (this.default_product && this.default_product.image_url) {
            this.$emit('setCurrentImage', this.default_product.image_url)
          }
        } else {
          this.$emit('setCurrentProduct', selected)
          this.$emit('setCurrentImage', selected.image_url)
        }
        this.$nextTick(() => {
          this.$emit('refresh')
        })
      }
    }
  }
</script>
